/**
 * Portail Controller
 */
function PortailCtrl(
    deconnectionService,
    authService,
    bandeauService,
    WCConstants,
    cards,
    $window,
    $sce,
    $timeout,
    notif,
    $translate,
    Analytics,
    $state
) {
    var vm = this,
        timeoutCurs = [];

    vm.authInfos = authService.getAuthInfos();
    if (!vm.authInfos) {
        deconnectionService.disconnect();
    }
    vm.nim = vm.authInfos && vm.authInfos.data.data ? vm.authInfos.data.data.nim : null;
    vm.version = WCConstants.version;
    vm.customer_gender = vm.authInfos.data.data.customers[0].sexe_client;
    vm.customer_name = vm.authInfos.data.data.customers[0].nom_client;
    vm.data = [];
    vm.message = '';
    vm.index_msg = 0;

    /**
     * Open the url if there's one, displays error otherwise
     * @param card the card on which the click is effective
     */
    vm.handleCardClick = function (card) {
        if (card.url) {
            $window.open(card.url);
            Analytics.trackEvent('Clic', card.name, card.url);
            return;
        }

        if (card.state) {
            $state.go(card.state);
            Analytics.trackEvent('Clic', card.name, card.url);
            return;
        }
        notif.error($translate.instant('APP_UNAVAILABLE'));
    };

    /**
     * Displays the sales message in the banner
     */
    vm.showMessage = function () {
        if (vm.data.length !== 0) {
            if (vm.data.nb_mess === 0) {
                vm.message = '';
            }
            else {
                vm.index_msg = vm.message === null || vm.index_msg === vm.data.nb_mess - 1 ? 0 : vm.index_msg + 1;
                vm.message = $sce.trustAsHtml(vm.data.messages[vm.index_msg].m_msg);
                timeoutCurs.push($timeout(vm.showMessage, vm.data.messages[vm.index_msg].m_timer * 1000 * 2));
            }
        }
    };

    /**
     * Ask for the sales messages
     */
    vm.refresh = function () {
        bandeauService.getMessages().then(function (res) {
            vm.data = res;
            vm.refresh_timer = vm.data.refresh;

            if (res === false) {
                vm.data = [];
                vm.refresh_timer = 120;
            }

            $timeout(vm.refresh, vm.refresh_timer * 1000);
            timeoutCurs.map(e => $timeout.cancel(e));
            timeoutCurs = [];
            vm.showMessage();
        });
    };

    vm.refresh();

    var cardsToActivate = [],
        servicesActivated = [];

    angular.forEach(vm.authInfos.data.data, function (value, key) {
        // check if module is active or not
        if (key.startsWith('module_') && value === 1) {
            cardsToActivate.push(key);
        }

        // check is service is active or not
        if (key === 'services') {
            angular.forEach(value, function (item) {
                if (item.etat && item.etat === 1) {
                    servicesActivated.push(item.id);
                }
            });
        }
    });

    vm.cards = cards.map(function (c) {
        // Search if module is activated ?
        angular.forEach(c.params, function (element) {
            c.active = cardsToActivate.indexOf(element) === -1 ? c.active : true;
        });

        // Search if service is activated ?
        angular.forEach(c.services, function (element) {
            c.active = servicesActivated.indexOf(element) === -1 ? c.active : true;
        });

        return c;
    });

    /**
     * Call for disconnect action
     */
    vm.disconnect = function () {
        deconnectionService.disconnect();
    };

    // if user is logged out in another tab, reload the portal
    $window.addEventListener('storage', function () {
        $window.location.reload();
    });

    return vm;
}

angular.module('app.portail.common').controller('PortailCtrl', PortailCtrl);
